module.exports = __webpack_public_path__ + "static/img/news.a278c76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-v2/news.png
// module id = +lNJ
// module chunks = 44